import { type ReactNode } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useConfig, useSetConfig } from '../hooks/use-config';
import { ToggleField } from './settings-field';

export function StreakToggle(): ReactNode {
  const qc = useQueryClient();
  const { data: cfg, isLoading } = useConfig('streak_engine_enabled');
  const save = useSetConfig();
  if (isLoading || cfg === undefined) return null;
  const on = cfg?.value === 'true' || cfg?.value === true;
  const toggle = (v: boolean): void => {
    save.mutate(
      { key: 'streak_engine_enabled', value: String(v) },
      {
        onSuccess: () => {
          // Fase 32: WeeklyRiskBanner and FailureStateBanner gate on this flag.
          // Mirror the bulk-reset invalidations so dashboards refresh now.
          qc.invalidateQueries({ queryKey: ['streak_engine_enabled'] });
          qc.invalidateQueries({ queryKey: ['collector-summary'] });
          qc.invalidateQueries({ queryKey: ['daily-earnings'] });
        },
      }
    );
  };
  return <ToggleField label="Motor de streaks" value={on} onChange={toggle} />;
}
